import React,{useState,useContext, useEffect} from 'react'
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import CustomTabPanel from '../CommonTabPannel/CustomTabPannel';
import { Button } from '@mui/material';
import SharedDataContext from '../../_helper/SharedData';

function CustomTabs({tabs}) {

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    console.log("newValue", newValue);
    setValue(newValue);
  };

  const { tabValue,setTabValue } = useContext(SharedDataContext);

  useEffect(()=>{
    console.log("context data ",tabValue);
    setTabValue(0)
    console.log("context data ",tabValue);
  },[])

  return (

  <Box sx={{ width: '100%' }}>

    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

      <Tabs value={tabValue} onChange={handleChange} aria-label="basic tabs example">
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} sx={{ textTransform: 'none' }}/>
        ))}
      </Tabs>
      
    </Box>

    {tabs.map((tab, index) => (
      <CustomTabPanel key={index} value={tabValue} index={index} >
        {tab.content}
      </CustomTabPanel>
    ))}

  </Box>
  
  )
}

export default CustomTabs;